export class ISelectionBase {
    constructor() {
        this.pageIndex = -1;
    }
}
export class SelectionBase {
    constructor() {
        this.pageIndex = -1;
    }
}
